function LinkedinIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1106_2258)">
        <path
          d="M28.7801 0H3.28503C1.53224 0 0.0981445 1.44 0.0981445 3.2V28.8C0.0981445 30.56 1.53224 32 3.28503 32H28.7801C30.5329 32 31.967 30.56 31.967 28.8V3.2C31.967 1.44 30.5329 0 28.7801 0ZM9.6588 27.2H4.87847V12.8H9.6588V27.2ZM7.26863 10.08C5.67519 10.08 4.40044 8.8 4.40044 7.2C4.40044 5.6 5.67519 4.32 7.26863 4.32C8.86208 4.32 10.1368 5.6 10.1368 7.2C10.1368 8.8 8.86208 10.08 7.26863 10.08ZM27.1867 27.2H22.4063V18.72C22.4063 17.4401 21.2909 16.32 20.0162 16.32C18.7414 16.32 17.626 17.4401 17.626 18.72V27.2H12.8457V12.8H17.626V14.72C18.4227 13.44 20.1755 12.48 21.6096 12.48C24.6372 12.48 27.1867 15.04 27.1867 18.08V27.2Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_2258">
          <rect
            width="31.8688"
            height="32"
            fill="white"
            transform="translate(0.0981445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LinkedinIcon;
